module.exports = __webpack_public_path__ + "static/FAQ-colours-a10681b77a9264d04566a3be75ff0430.jpg";